import React, { useCallback, useRef, useState } from 'react';
import { ATMButton, ATMModal } from 'shared-it-appmod-ui';
import {
  ToastSuccess,
  ToastError,
} from 'src/components/atoms/toaster/toaster.component';
import { ITailNumber, ITailNumberForm } from 'src/models/tail-number.model';
import { useTailNumberContext } from 'src/contexts/tail-number.context';
import Lang from 'src/libraries/language';
import { actionTypes } from 'src/ducks/tail-number.duck';
import { getTailNumberStatus } from 'src/selectors/tail-number.selector';
import TailNumbersForm from '../tail-numbers-form/tail-numbers-form.component';
import style from '../tail-numbers-list/tail-numbers-list.module.scss';

type IProp = {
  data: ITailNumber;
};

const TailNumbersEdit: React.FC<IProp> = ({ data }) => {
  const { state, actions } = useTailNumberContext();
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const formRef = useRef<HTMLFormElement>(null);

  let defaultValues: Partial<ITailNumber> = {
    tailNumber: '',
  };

  if (data) {
    defaultValues = data;
  }

  const editStatus = getTailNumberStatus(state, actionTypes.TAIL_NUMBER_UPDATE);

  const handleSave = useCallback(() => {
    if (formRef && formRef.current) {
      formRef.current.handleSubmit();
    }
  }, [formRef]);

  const handleSubmit = useCallback(
    async (value) => {
      const formData: ITailNumberForm = {
        tailNumber: value.tailNumber,
      };
      const response = await actions.updatePUT(value.tailId, formData);
      if (!response.error) {
        ToastSuccess(
          Lang.formatString(
            Lang.MSG_TAIL_EDIT_SUCCESS,
            formData.tailNumber ? formData.tailNumber : value.tailNumber
          )
        );
      } else {
        ToastError(response.error.message);
      }
      setIsEditOpen(false);
      actions.listGET();
    },
    [actions, setIsEditOpen]
  );

  return (
    <ATMModal
      open={isEditOpen}
      size="tiny"
      trigger={
        <ATMButton
          className={style.actionIcon}
          basic
          icon="edit outline"
          onClick={() => setIsEditOpen(true)}
        />
      }
      header={Lang.LBL_MODIFY_TAIL_NUMBER}
      content={
        <div className={style.content}>
          <TailNumbersForm
            defaultValues={defaultValues}
            formRef={formRef}
            handleSubmit={handleSubmit}
            handleEnable={(value) => setIsDirty(value)}
          />
        </div>
      }
      actions={
        <div className={style.actionBtns}>
          <ATMButton
            basic
            color="blue"
            content={Lang.LBL_CANCEL}
            onClick={() => {
              setIsEditOpen(false);
            }}
          />
          <ATMButton
            primary
            content={Lang.LBL_SAVE}
            disabled={!isDirty || editStatus.fetching}
            onClick={handleSave}
            loading={editStatus.fetching}
          />
        </div>
      }
    />
  );
};

export default TailNumbersEdit;
